module.exports = __webpack_public_path__ + "img/image11.07f75249.jpg";